import store from './store';

export default function* () {
    yield* [
        ...store
    ];
}